<template>
    <div class="preview-page">
        <!-- 顶部工具条：左侧范围切换，右侧搜索 -->
        <div class="preview-toolbar">
            <div v-if="!(this.$store.state.user.token == undefined || this.$store.state.user.token == '')" class="preview-toolbar__roles">
                <div class="role-switch">
                    <el-button class="role-switch__btn" :class="{ 'is-active': collectedRole == 'default' }" @click="searchByCollectedRole('default')">ALL</el-button>
                    <el-button class="role-switch__btn" :class="{ 'is-active': collectedRole == 'myJoin' }" @click="searchByCollectedRole('myJoin')">参与</el-button>
                    <el-button class="role-switch__btn" :class="{ 'is-active': collectedRole == 'private' }" @click="searchByCollectedRole('private')">私有</el-button>
                </div>
            </div>
            <div class="preview-toolbar__search">
                <el-input v-model="searchText" placeholder="搜索一下" class="preview-search" @keydown="searchEnter" clearable>
                    <template #append>
                        <el-button @click="search()">
                            <el-icon>
                                <Search />
                            </el-icon>
                        </el-button>
                    </template>
                </el-input>
            </div>
        </div>

        <!-- 内容区域：收藏夹卡片列表 -->
        <el-row class="preview-grid" :gutter="16">
            <el-col v-for="item in collectedList" :key="item.id" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
                <doc-collected-card v-bind:data="item"></doc-collected-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import DocCollectedCard from './components/DocCollectedCard';
import request from '../../utils/request.js';
import { Search, Share, Guide } from '@element-plus/icons';
export default {
    data() {
        return {
            collectedList: [],
            searchText: '',
            searchMode: '',
            collectedRole: 'default'
        };
    },
    setup() {
        // 数据
        let sum = ref(0);

        //监视属性
        watch(sum, (newValue, oldValue) => {
            // 回调函数形式
            console.log('求和的值变了', '变化后的值是' + newValue, '变化前的值是' + oldValue);
        });
        //返回对象
        return {
            sum
        };
    },
    mounted() {
        document.title = 'Hidoc-首页';
        // debugger;
        let token = this.$store.state.user.token;
        console.log('token: ' + token);
        this.search();
    },
    components: { DocCollectedCard, Search },
    methods: {
        searchEnter(e) {
            if (e.keyCode == 13) {
                this.search();
            }
        },
        searchByCollectedRole(collectedRole) {
            this.collectedRole = collectedRole;
            this.search();
        },
        search() {
            console.log('搜索 ' + this.searchMode + ' ' + this.searchText);
            request({
                url: '/collected/preview',
                method: 'post',
                data: { mode: this.searchMode, keyword: this.searchText, collectedRole: this.collectedRole }
            }).then(res => {
                if (res.code == 0) {
                    this.collectedList = res.data;
                }
            });
        },
        register() {
            this.$router.push({ path: '/register', params: {} });
        },
        login() {
            this.$router.push({ path: '/login', params: {} });
        },
        async logout() {
            await this.$store.dispatch('user/logout');
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        }
    }
};
</script>

<style lang="scss" scoped>
.preview-page {
    /* 局部覆盖主色，与登录页保持同一套视觉语言 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    --pv-text: #1f2d3d;
    --pv-text-sub: #8a94a6;
    --pv-line: #e6eaf0;

    /* 浅色画布由外层的 .app-main-body 提供，这里只负责内容排布 */
    color: var(--pv-text);
}

/* ---------- 工具条 ---------- */
.preview-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 18px;
}

.preview-toolbar__roles {
    display: flex;
}

/* 范围切换：分段控件，替代默认的彩色按钮 */
.role-switch {
    display: inline-flex;
    gap: 4px;
    padding: 3px;
    border: 1px solid var(--pv-line);
    border-radius: 11px;
    background-color: #ffffff;
    box-shadow: 0 1px 2px rgba(28, 47, 84, 0.04);
}

.role-switch__btn {
    min-width: 68px;
    height: 28px;
    margin: 0 !important;
    padding: 0 14px;
    border: 0 !important;
    border-radius: 8px !important;
    background-color: transparent;
    color: var(--pv-text-sub);
    font-size: 13px;
    font-weight: 500;
    box-shadow: none;
    transition:
        background-color 0.2s,
        color 0.2s;
}

.role-switch__btn:hover,
.role-switch__btn:focus {
    background-color: #f2f5fa;
    color: var(--pv-text);
}

.role-switch__btn.is-active {
    background-color: var(--el-color-primary-light-9);
    color: var(--el-color-primary);
}

/* ---------- 搜索框 ---------- */
.preview-toolbar__search {
    flex: 0 1 280px;
    min-width: 200px;
}

.preview-search :deep(.el-input__wrapper) {
    border-radius: 10px 0 0 10px;
    background-color: #ffffff;
    box-shadow: 0 0 0 1px var(--pv-line) inset;
    transition: box-shadow 0.2s;
}

.preview-search :deep(.el-input__wrapper:hover) {
    box-shadow: 0 0 0 1px #cfd8e6 inset;
}

.preview-search :deep(.el-input__wrapper.is-focus) {
    box-shadow: 0 0 0 1px var(--el-color-primary) inset;
}

.preview-search :deep(.el-input-group__append) {
    padding: 0;
    border: 0;
    border-radius: 0 10px 10px 0;
    background-color: var(--el-color-primary);
    box-shadow: none;
}

.preview-search :deep(.el-input-group__append .el-button) {
    height: 32px;
    margin: 0;
    padding: 0 14px;
    border: 0;
    border-radius: 0;
    background-color: transparent;
    color: #ffffff;
}

.preview-search :deep(.el-input-group__append .el-button:hover) {
    background-color: var(--el-color-primary-dark-2);
    color: #ffffff;
}

/* ---------- 卡片栅格 ---------- */
.preview-grid :deep(.el-col) {
    margin-bottom: 16px;
}

/* ---------- 移动端适配 ---------- */
@media (max-width: 768px) {
    .preview-toolbar {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }

    .role-switch {
        display: flex;
        width: 100%;
    }

    .role-switch__btn {
        flex: 1 1 0;
        min-width: 0;
    }

    .preview-toolbar__search {
        flex: 1 1 auto;
        min-width: 0;
    }
}
</style>
